import { GetterTree } from 'vuex';
import { RootState } from '@/store/state';
import { FamilyState } from './state';

export const getters: GetterTree<FamilyState, RootState> = {
  families: s => s.families,
  familiesLoading: s => s.familiesLoading,
  familiesError: s => s.familiesError,

  activeFamilyId: s => s.activeFamilyId,
  activeSubgraph: s => s.activeSubgraph,
  activeSubgraphLoading: s => s.activeSubgraphLoading,
  activeSubgraphError: s => s.activeSubgraphError,

  activeMembers: s => s.activeSubgraph?.members ?? [],
  activeRelationships: s => s.activeSubgraph?.relationships ?? [],
  activePhotos: s => s.activeSubgraph?.photos ?? [],
  activeFaceCrops: s => s.activeSubgraph?.faceCrops ?? [],

  selectedMemberId: s => s.selectedMemberId,
  selectedMember: s => s.activeSubgraph?.members.find(m => m.id === s.selectedMemberId) ?? null,
  wizardOpen: s => s.wizardOpen,

  publicSubgraph: s => s.publicSubgraph,
  publicSubgraphLoading: s => s.publicSubgraphLoading,
  publicSubgraphError: s => s.publicSubgraphError,

  /**
   * Family size count for a given family id (drawn from the families list).
   * Returns null if the family hasn't been loaded.
   */
  familyMemberCount:
    s =>
    (familyId: string): number | null => {
      if (s.activeFamilyId === familyId && s.activeSubgraph) {
        return s.activeSubgraph.members.length;
      }
      return null;
    }
};
